import { QueryClient } from '@tanstack/react-query';
import { CASES_PAGE_LIST, EVENTS_PAGE_LIST } from 'config/paths';
import { Params, type Location as RouterLocation } from 'react-router-dom';

const getQueryByIdFromLocation = (
  location: RouterLocation,
  routeParams: Readonly<Params<string>>,
) => {
  const searchParams = new URLSearchParams(location.search);

  const eventId = searchParams.get('eventId') ?? routeParams?.eventId;
  const caseId = searchParams.get('caseId') ?? routeParams?.caseId;

  if (eventId) {
    return ['EVENT_BY_ID', eventId];
  }

  if (caseId) {
    return ['GET_CASE', caseId];
  }

  return [];
};

const getQueryListKeyFromLocation = (location: RouterLocation) => {
  const currentUrl = location.pathname;

  if (currentUrl.includes(EVENTS_PAGE_LIST)) return ['EVENTS'];
  if (currentUrl.includes(CASES_PAGE_LIST())) return ['GET_CASES'];

  return [];
};
const getParamsFromListQuery = (queryClient: QueryClient, queryKeyListToGet: string[]) => {
  if (queryKeyListToGet.length > 0) {
    const queries = queryClient.getQueriesData({
      predicate: (query) => queryKeyListToGet.every((key) => query.queryKey.includes(key)),
    });
    if (queries?.length > 0) {
      const [queryKey] = queries[queries.length - 1];

      const queryFilters = queryKey.find((key) => typeof key === 'object') ?? {};

      return Object.entries(queryFilters).reduce((acc, [key, value]) => {
        if (key === 'assets') {
          return {
            ...acc,
            [key]: Array.isArray(value) ? value.map((item) => item.id).join(',') : String(value),
          };
        }
        if (value && (!Array.isArray(value) || value.length > 0)) {
          return {
            ...acc,
            [key]: Array.isArray(value) ? value.join(',') : String(value),
          };
        }
        return acc;
      }, {} as Record<string, string>);
    }
  }
  return {};
};

export const getInfoByCurrentUrl = (
  location: RouterLocation,
  queryClient: QueryClient,
  routeParams: Readonly<Params<string>>,
) => {
  const queryKeyListToGet = getQueryListKeyFromLocation(location);
  const parsedToUrlParams = getParamsFromListQuery(queryClient, queryKeyListToGet);

  const queryKeyId = getQueryByIdFromLocation(location, routeParams);

  const queriesById =
    queryKeyId && queryKeyId.length > 0
      ? queryClient.getQueriesData({
          predicate: (query) => queryKeyId.every((key) => query.queryKey.includes(key)),
        })
      : [];

  if (queriesById && queriesById.length > 0) {
    const [, queryData] = queriesById[queriesById.length - 1];

    if (queryData && typeof queryData === 'object' && 'asset' in queryData) {
      return {
        ...parsedToUrlParams,
        assetId: (queryData.asset as { id: string }).id,
      };
    }
  }
  return parsedToUrlParams;
};
